import { SIDENAV } from '../mutations';

const namespaced = true;

const state = {
  collapsed: localStorage.getItem('Mentoring.Web|Sidenav|Collapsed') === 'true' || false,
};

const getters = {
  collapsed: (state) => state.collapsed,
};

const mutations = {
  [SIDENAV.TOGGLE_DRAWER]: (state, val) => {
    state.collapsed = val;
  },
};

const actions = {
  toggleSidenav({ commit, state }) {
    const value = !state.collapsed;
    localStorage.setItem('Mentoring.Web|Sidenav|Collapsed', value);
    commit(SIDENAV.TOGGLE_DRAWER, value);
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};